<template>
    <section class="page-edit container">
        <BaseButtonBack></BaseButtonBack>
        <!-- <BaseButton class="page-edit__save-btn" theme="primary" @click.native="save" title="test header Save" v-if="metafields.length"></BaseButton> -->
        <Section v-if="upscribeMetafields && upscribeMetafields.length">
            <SectionInfo slot="info" :title="'Integration'" text="Add your data on the right.">
            </SectionInfo>

            <template slot="categories">
                <MetafieldsEditContainer
                    class="page-edit__tree"
                    :metafields="upscribeMetafields"
                    :storeName="store"
                    :loading="areMetafieldsSaving"
                 />
                <br/><br/>

                <BaseButton 
                    class="page-edit__save-btn" 
                    theme="primary" 
                    @click.native="save({iterations: [{
                        store: 'shopProductsIntegrationsUpscribe',
                        metafields: upscribeMetafields
                    }]})" 
                    title="Save" 
                    :loading="areMetafieldsSaving" 
                    v-if="upscribeMetafields.length"
                >
                </BaseButton>
            </template>
        </Section>

        <Section>
            <SectionInfo slot="info" :title="item.title || 'Metafield values'" text="Add your data on the right."></SectionInfo>

            <template slot="categories">
                <MetafieldsEditContainer
                    class="page-edit__tree"
                    :metafields="metafields"
                    :storeName="store"
                    :loading="areMetafieldsSaving"
                 />
                <br/><br/>
                
                <BaseButton class="page-edit__save-btn" theme="primary" @click.native="save(null)" title="Save" :loading="areMetafieldsSaving" v-if="metafields.length"></BaseButton>
            </template>
        </Section>
    </section>
</template>

<script>
import MetafieldsEditContainer from '@/components/metafields-edit/MetafieldsEditContainer'
import Section from '@/components/Section'
import SectionInfo from '@/components/SectionInfo'
import Store from '@/stores'
import { mapGetters, mapState } from 'vuex'
import {
    windowConfirm,
    confirmBrowserQuit,
    reformatRepeaterKeys,
    prepareSavePayload
} from '@/helpers'
import { logger } from '@/helpers'

export default {
    components: {
        Section,
        SectionInfo,
        MetafieldsEditContainer
    },

    data() {
        return {
            store: this.$route.meta.store
        }
    },

    computed: {
        ...mapGetters('unsavedChanges', ['areChangesUnsaved']),
        ...mapGetters('shopifyApi', ['openedHTTPs']),
        ...mapState('loaders', ['areMetafieldsSaving']),
        ...mapState('settingsIntegrations', ['integrations']),
        upscribeMetafields() {
            return this.$store.getters[`shopProductsIntegrationsUpscribe/metafields`]
        },
        metafields() {
            return this.$store.getters[`${this.store}/metafields`]
        },
        id() {
            return this.$store.getters[`${this.store}/id`]
        },
        scope() {
            return this.$store.getters[`${this.store}/scope`]
        },
        item() {
            return this.$store.getters[`${this.store}/item`] || {}
        },
        showBackBtn() {
            return (
                this.store === 'shopGlobalsEdit' ||
                this.store === 'shopCustomobjectsEdit' ||
                this.item['back_url']
            )
        }
    },

    methods: {
        accordionsToOpen(el) {
            const arr = []

            do {
                if (el.classList.length && el.classList.contains('js-base-accordion')) {
                    arr.push(el.__vue__._uid)
                }
                el = el.parentNode
            } while (el.id !== 'js-metafields-ROOT')

            return arr
        },
        scrollToInvaildForms() {
            const firstError = this.$validator.errors.items.length
                ? this.$validator.errors.items[0]
                : null
            const elWithError = firstError ? document.getElementById(firstError.field) : null

            if (!elWithError) {
                console.warn('elWithError not found', elWithError)
                return
            }

            for (let i = 0; i < this.accordionsToOpen.length; i++) {
                const uid = this.accordionsToOpen[i]
                this.$eventBus.$emit('openBaseAccordion', uid)
            }

            this.$nextTick(() => {
                this.$scrollTo(elWithError, 1000)
            })
        },
        showLoadingWarningBanner({ message }) {
            this.$store.commit('banners/CLOSE_BANNER')
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'warning',
                title: message
            })

            const unwatch = this.$watch('openedHTTPs', newVal => {
                if (newVal === 0) {
                    this.$store.commit('banners/CLOSE_BANNER')
                    unwatch()
                }
            })
        },
        async sendMetafieldsRelatedRequests() {
            // TODO: 1. Add loading state for MetafieldEditRelation when relations are not fetched yet
            // TODO: 2. Add empty message to MetafieldEditRelation when there are no items
            const usedEndpoints = []
            const usedKeys = []
            const relationRequests = []
            const customObjRequests = []

            const _collectRelationRequest = ({ endpoint }) => {
                if (endpoint === 'variant') {
                    endpoint = 'product'
                }

                if (!usedEndpoints.includes(endpoint)) {
                    this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                        key: endpoint,
                        bool: true
                    })
                    usedEndpoints.push(endpoint)
                    relationRequests.push(
                        this.$store.dispatch(`shopifyApi/REQUEST`, { endpoint: `item/${endpoint}` })
                    )
                }
            }

            const _collectCustomObjRequest = ({ groupId }) => {
                if (!usedKeys.includes(groupId)) {
                    this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                        key: groupId,
                        bool: true
                    })
                    usedKeys.push(groupId)
                    customObjRequests.push(
                        this.$store.dispatch(`shopCustomobjectsList/GET_CUSTOM_OBJECTS`, {
                            groupId
                        })
                    )
                }
            }

            const _searchForRequests = fields => {
                for (let i = 0; i < fields.length; i++) {
                    const item = fields[i]

                    switch (item.type) {
                        case 'relation':
                            _collectRelationRequest({ endpoint: item.subForm.relateTo })
                            break

                        case 'custom-object':
                            _collectCustomObjRequest({ groupId: item.subForm.groupID })
                            break

                        case 'repeater':
                            _searchForRequests(item.schema)
                            break

                        case 'group':
                            _searchForRequests(item.children)
                            break

                        default:
                            break
                    }
                }
            }

            _searchForRequests(this.metafields)
            const relations = await Promise.all(
                relationRequests.map(async (request, i) => {
                    try {
                        return { result: await request }
                    } catch (err) {
                        return { error: err }
                    }
                })
            )
            const customObjs = await Promise.all(
                customObjRequests.map(async (request, i) => {
                    try {
                        return { result: await request }
                    } catch (err) {
                        return { error: err }
                    } finally {
                    }
                })
            )

            for (let i = 0; i < relations.length; i++) {
                const rel = relations[i]
                const endpoint = usedEndpoints[i]
                if (!rel || rel.error) {
                    this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                        key: endpoint,
                        bool: false
                    })
                    continue
                }

                const payload = {
                    key: endpoint,
                    data: rel.result.items
                }
                this.$store.commit('cacheMetafields/SET_RELATIONS', payload)
                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                    key: endpoint,
                    bool: false
                })
            }

            for (let i = 0; i < customObjs.length; i++) {
                const obj = customObjs[i]
                const groupId = usedKeys[i]
                if (!obj || obj.error) {
                    this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                        key: groupId,
                        bool: false
                    })
                    continue
                }
                const payload = {
                    key: groupId,
                    data: obj.result
                }
                this.$store.commit('cacheMetafields/SET_CUSTOM_OBJS', payload)
                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                    key: groupId,
                    bool: false
                })
            }
        },
        async saveEventHandlerWrapper() {
            this.save({
                iterations: [
                    {
                        store: this.store,
                        metafields: this.metafields
                    },
                    {
                        store: 'shopProductsIntegrationsUpscribe',
                        metafields: this.upscribeMetafields
                    }
                ]
            })
        },
        async save(options) {
            const defaultOptions = {
                iterations: [
                    {
                        store: this.store,
                        metafields: this.metafields
                    }
                ]
            }
            options = options || defaultOptions

            this.$store.commit('banners/CLOSE_BANNER') // i.e. closes opened banner ('Fields saved') new banner may show after 30seconds

            if (this.areMetafieldsSaving) {
                return this.showLoadingWarningBanner({
                    message: 'Wait until saving process will be finished.'
                })
            }

            if (this.openedHTTPs > 0) {
                return this.showLoadingWarningBanner({
                    message: 'Wait for Airfields to be fully loaded.'
                })
            }

            this.$store.commit('loaders/SET_METAFIELDS_SAVING', true)

            const isValid = await this.$validator.validateAll()
            if (!isValid) {
                if (this.$validator.errors.items.length) {
                    this.$store.commit('banners/SHOW_BANNER', {
                        status: 'warning',
                        title: 'There is invalid data in the form. Please check the form again.'
                    })
                    this.scrollToInvaildForms()

                    this.$store.commit('loaders/SET_METAFIELDS_SAVING', false)
                    return
                }
            }

            let error = false

            for (const { store, metafields } of options.iterations) {
                if (!metafields || !metafields.length) {
                    continue
                }
                const reformatted = reformatRepeaterKeys(metafields)
                const splittedPayload = prepareSavePayload(reformatted)

                // If user changed nothing show success save banner :)
                if (!splittedPayload.length) {
                    this.showSuccessSaveBanner()
                    this.$store.commit('loaders/SET_METAFIELDS_SAVING', false)
                    continue
                }

                const promises = []
                for (let i = 0; i < splittedPayload.length; i++) {
                    const payload = splittedPayload[i]
                    promises.push(this.$store.dispatch(`${store}/SAVE_METAFIELDS`, payload))
                }

                try {
                    // Save Requests
                    await Promise.all(promises)
                    // After save refetch metafields
                    const { metafields } = await this.$store.dispatch(`${store}/GET_METAFIELDS`)
                    if (metafields) {
                        this.$store.commit(`${store}/SET_METAFIELDS`, {
                            metafields,
                            isRefetch: true
                        })
                    }
                    // After success save trigger reset of hasChanged flags and show success banner
                    this.$eventBus.$emit('AFTER_METAFIELDS_SUCCESS_SAVE')
                } catch (e) {
                    error = true
                }
            }

            if (error) {
                this.$store.commit('banners/SHOW_BANNER', {
                    status: 'warning',
                    title: 'Save failed.',
                    message: 'There was a problem with connection.</br>Please try again.'
                })
            } else {
                this.showSuccessSaveBanner()
            }

            this.$store.commit('loaders/SET_METAFIELDS_SAVING', false)
        },

        backToItem() {
            if (this.store === 'shopGlobalsEdit') {
                this.$router.push('/')
            } else if (this.store === 'shopCustomobjectsEdit') {
                this.$router.push(`/customobjects/manage?id=${this.$route.query.id}`)
            } else {
                if (!window.shopify) {
                    return console.error('window.shopify is not available')
                }
                // Use new App Bridge navigation API
                // Migration guide line 488: Redirect.Action.APP -> shopify.navigation.navigate()
                window.shopify.navigation.navigate(`/admin${this.item['back_url']}`)
            }
        },

        showSuccessSaveBanner() {
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'success',
                title: 'Fields saved.'
            })
        }
    },

    watch: {
        areChangesUnsaved(val) {
            if (val) {
                confirmBrowserQuit(this.$translations['UNSAVED_CHANGES_MESSAGE'])
            } else {
                confirmBrowserQuit('', true)
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        /*
            Shopify bug workaround: redirect to the resource selector if there is no id.
            Shopify randomly deletes id from the url.
        */
        const shop = to.query.shop
        const missingId = to.query.id === undefined

        const pagesToRedirect = ['/products/edit', '/collections/edit', '/variants/edit', '/pages/edit', '/blogs/edit', '/articles/edit']

        if (missingId && pagesToRedirect.includes(to.path)) {
            logger('confirmation_url: ', {
                path: '/select-resource',
                query: { shop, redirect: to.path }
            })
            next({ path: '/select-resource', query: { shop, redirect: to.path } })
            return
        }

        try {
            const stores = [to.meta.store]
            if (to.meta.integrations) {
                await Store.dispatch(`settingsIntegrations/GET_SETTINGS`)

                const integrations = Store.getters[`settingsIntegrations/integrations`]
                if (integrations && integrations.upscribe.settings.enabled === 'true') {
                    stores.push('shopProductsIntegrationsUpscribe')
                }
            }

            for (const store of stores) {
                if (to.query.id) {
                    Store.commit(`${store}/SET_ID`, { id: to.query.id })
                }

                if (to.query.key) {
                    Store.commit(`${store}/SET_KEY`, { key: to.query.key })
                }

                const { metafields } = await Store.dispatch(`${store}/GET_METAFIELDS`)

                if (metafields) {
                    Store.commit(`${store}/SET_METAFIELDS`, { metafields })
                }
            }
        } catch (error) {
            console.error(`Couldn't resolve ${to.name} beforeRouteEnter requests`, { error })
            next({
                name: 'app.error',
                query: { type: 'API' }
            })
        }

        if (to.name !== 'globals.edit') {
            await Store.dispatch(`${to.meta.store}/GET_ITEM`, {
                id: to.query.id,
                collectionType: to.query.type
            })
        }

        next()
    },

    beforeRouteLeave(to, from, next) {
        const _next = () => {
            this.$store.commit('unsavedChanges/RESET_STATE')
            next()
        }
        const _stay = () => {
            next(false)
        }

        if (this.areChangesUnsaved) {
            const answer = windowConfirm(this.$translations['UNSAVED_CHANGES_MESSAGE'])

            if (answer) {
                _next()
            } else {
                _stay()
            }
        } else {
            _next()
        }
    },

    created() {
        this.sendMetafieldsRelatedRequests()
        window.addEventListener('save', this.saveEventHandlerWrapper, false)

        if (!this.metafields.length) {
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'warning',
                title: 'There are no Airfields yet.',
                message: `Please add Airfields to ${this.scope} first to be able to edit this item.`
            })
        }
    },

    beforeDestroy() {
        window.removeEventListener('save', this.saveEventHandlerWrapper)
        this.$store.commit('banners/CLOSE_BANNER')
    }
}
</script>

<style lang="scss">
@import './src/assets/styles/grid.scss';
@import './src/assets/styles/breakpoints.scss';

.page-edit {
    .page-edit__tree {
        @include media(ltMobile) {
            margin-left: -$container-gutter-mobile;
            width: calc(100% + 2 * #{$container-gutter-mobile});
        }
    }

    .page-edit__save-btn {
        display: flex;
        margin-left: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/page-edit.vue